<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div v-if="!modoEdicao">
        <div class="form-edit-page" style="display: flex; gap: 10px; align-items: end;">
            <div class="form-item flexible">
                <label class="label-caption" for="nmPesquisa">Pesquisar</label>
                <input type="text" v-model="nmPesquisa" id="nmPesquisa" maxlength="80" v-uppercase />
            </div>
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--add" @click="modoEdicao = true" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>

        <div class="margin-top10">
            <table>
                <thead>
                    <tr>
                        <th class="col-width-char10">Data</th>
                        <th>Nome Documento</th>
                        <th class="col-width-char10">Validade</th>
                        <th class="col-width-char30">Situação</th>
                        <th class="col-width-char10">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                        <td class="col-width-char10">{{ formatDateFromJson(obj.dtanexo) }}</td>
                        <td>{{ obj.nmdoc }}</td>
                        <td class="col-width-char10">{{ formatDateFromJson(obj.dtvalidade) }}</td>
                        <td class="col-width-char30">{{ obj.situacaonm }}</td>
                        <td class="col-width-char10"><div class="row-left">
                            <button class="btn-icon btn-icon--pdf" @click="lerAnexo(obj)"></button>
                        </div></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


    <div v-if="modoEdicao">
        <AnexoUpload :idAnexoGrupo="2" @close="modoEdicao = false" @salvo="lerDados" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { formatDateFromJson } from '@/funcoes/utils';
import { genericPost } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import AnexoUpload from './AnexoUploadPage.vue';
import MensagemAlerta from '../utils/MensagemAlerta.vue';

const emit = defineEmits(['close']);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const msgAlerta=ref(null);
const nmPesquisa = ref('');

const closeForm = () => {emit('close');}

const lerAnexo = async(obj) => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const dados = {id: obj.id};
        const req = await genericPost('/main/anexo_base64', dados);
        const pdfBase64 = req.anexo;
        const pdfWindow = window.open("");
        const iframe = pdfWindow.document.createElement("iframe");
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.src = "data:application/pdf;base64," + encodeURIComponent(pdfBase64);
        pdfWindow.document.body.appendChild(iframe);
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
};

const lerDados = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await genericPost('/listas/anexos', {
            idep: globalStore.idep,
            idestabelecimento: globalStore.idestabelecimento,
            intparam1: 2,
            nmpesquisar: nmPesquisa.value});
        lsDados.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}

onMounted(lerDados);
</script>
